/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Col_FormatInputs */



/**
* | output |
* | --- |
* | "Format" |
*
* @param {Tournaments_Col_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_col_format = /** @type {((inputs?: Tournaments_Col_FormatInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Col_FormatInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato")
	return /** @type {LocalizedString} */ ("Format")
});